import { LOCALE_ID, NgModule } from '@angular/core';
import localeNl from '@angular/common/locales/nl';
import { AuthenticationOptions, AuthenticationType } from 'azure-maps-control';
import { AzureMapsModule } from 'ng-azure-maps';
import { AppComponent } from './app.component';
import { AppSharedModule } from './app.shared.module';
import { registerLocaleData } from '@angular/common';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

const data = require('../assets/data/appConfig.json');

const options: AuthenticationOptions = {
  authType: AuthenticationType.subscriptionKey,
  subscriptionKey: data.azureKey,
};
registerLocaleData(localeNl, 'nl');

@NgModule({
  providers: [
    { provide: LOCALE_ID, useValue: 'nl' },
    provideClientHydration()
  ],
  imports: [
    BrowserModule,
    AppSharedModule,
    AzureMapsModule.forRoot({
      authOptions: options,
    }),
  ],
  exports: [AzureMapsModule],
  bootstrap: [AppComponent],
})
export class AppModule { }
